<i18n src="../../../locales/lang.json"></i18n>
<template>
  <div class="row p-0 m-0">
    <div class="col-12" style="position:relative">
      <i class="icon-move handle" style="margin-top:12px;float:left;"></i>
      <div @click="clickSettings(el)" v-html="content" class="p-3 col-8 col-md-8 cursor-pointer" :contenteditable="false" style="border:solid 1px #ccc; float:left;left:38px;">
      </div>     
      <!--<mce-editor filefolder="News" v-bind:doinit="false" ref="mce" value="" name="description"></mce-editor>-->
      <i class="icon-typography" style="margin-top:-6px; left:75px;position:absolute;color:#ccc;background-color:white;"></i>
      <element-controls class="element-controls" v-bind:el="el" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings"></element-controls>
    </div>

  </div>
</template>

<script>
  import MceEditor from "../../mce/mce-editor.vue";
  export default {
    name: "element-html-editor",
    components: {
      MceEditor
    },
    props: {
      el: {
        type: Object,
        default: null
      },
      overelement: {
        type: Object,
        default: null
      },
    },
    data() {
      return {
        content: "Click here to set text in editor",//this.el.Text,
        description: '',
      };
    },
    methods: {
      setValue: function (val) {
        alert(val);
        this.el.Text = val;
        el.IsChanged = true;
        el.Overridden = true;
        this.onChange();
      },
      onChange() {
        this.el.IsChanged = true;
        this.$store.markAsChanged();
      },
      handleInput: function (e, el) {
        var val = e.target.innerHTML.replace(/(?:^(?:&nbsp;)+)|(?:(?:&nbsp;)+$)/g, '');
        this.el.Text = val;
        el.IsChanged = true;
        el.Overridden = true;
        //if (el.ParentId == null) {
        //  el.ParentId = el.Id;
        //  el.Id = -1;
        //}
      },
      textChanged(el) {
        el.IsChanged = true;
        el.Overridden = true;
        //if (el.ParentId == null) {
        //  el.ParentId = el.Id;
        //  el.Id = -1;
        //}
        this.onChange(null);
      },
      clickSettings(el) {
        this.$emit('clickSettings', el);
      },
      clickItem(el) {
        this.$emit('clickItem', el);
      },
      deleteItem(id) {
        if (id == null || typeof id == "undefined")
          id = this.value.Id;
        this.$emit('deleteItem', id);
      },
      getId() {
        return this._uid;
      },

      handleRefresh(val) {
        this.$forceUpdate();
      },
      init() {
        //alert("dfg1");
        //this.$refs.mce.value = "fsf";
        //this.$refs.mce.setValue("gsdg");
        //this.$refs.mce.initMCE();
        //this.handleRefresh('');
        //alert("dfg2");
      }
    },
    computed: {

    },
    watch: {
      el: function (newVal, oldVal) {
        this.content = newVal.Text;
        //this.$forceUpdate();
        //this.reload();
      }
    },
    mounted() {
      this.init();
      //this.content = el.Text;
      //$('body').on('dragstart drop', function (e) {
      //  e.preventDefault();
      //  return false;
      //});
    },
    created() {
      this.$root.$on('input', this.setValue);
    },
  };

</script>

<style scoped>

  /*Make the controls a little more quite*/

  .icon-move, .item .element-controls, .item btn-icon, .item .btn-icon i {
    color: #ddd;
  }

  .item .form-control {
    border-color: transparent;
  }

  .item:focus-within .form-control, .form-control:active, .form-control:focus {
    border-color: #2196f3;
  }

  .item:focus-within .element-controls, .item:hover .element-controls,
  .item:hover .icon-move,
  .item:focus-within .icon-move,
  .item:hover .btn-icon i, .item:focus-within .btn-icon i {
    color: black;
  }

  .item:active .custom-control-label::before, .item:focus-within .custom-control-label::before, .item:hover .custom-control-label::before {
    border-color: black;
  }

  /*End Make the controls a little more quite*/

  .handle {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/procedure/procedure-editor-elements/element-html-editor.vue